import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import AlertDialog from '../../common/AlertDialog';
import {getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, isEmptyArray} from '../../common/Global/commonFunctions';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import { PageSaveButton, UserRoleCheckBoxLayout } from '../../common/Global/globalStyles.style';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

class EditSubscription extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            showLoader:false,
            componentDidMountFlag:false,
            singleLevelRoleArr :{},
            companyName:"",
            clientId:props.match.params.id,
            datalist:[],
            showAlertDialogInfo:false,  
            alertDialogMessageInfo:"",
            updatedFeatures:[],
        }
        userDetails = getLocalStorageVariables();
		themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getInitData();
    }

    handleRights = (e, idx, subIdx, featureIdx) => {
        const { datalist, updatedFeatures } = this.state;
        const isChecked = e.target.checked;

        // Clone datalist deeply
        const updatedDatalist = datalist.map((menuItem, menuIndex) => {
            if (menuIndex !== idx) return menuItem;

            return {
                ...menuItem,
                subMenuList: menuItem.subMenuList.map((subMenuItem, subIndex) => {
                    if (subIndex !== subIdx) return subMenuItem;

                    return {
                        ...subMenuItem,
                        featureList: subMenuItem.featureList.map((featureItem, featureIndex) => {
                            if (featureIndex !== featureIdx) return featureItem;
                            return {
                                ...featureItem,
                                hasRights: isChecked ? "Y" : "N",
                            };
                        }),
                    };
                })
            }
        })
        const changedFeature = updatedDatalist[idx].subMenuList[subIdx].featureList[featureIdx];
        const updatedItem = {
            featureName: changedFeature.featureName,
            hasRights: changedFeature.hasRights,
            menuName: updatedDatalist[idx].name,
            subMenuName: updatedDatalist[idx].subMenuList[subIdx].subMenuName
        };

        const existingIndex = updatedFeatures.findIndex(item =>
            item.featureName === updatedItem.featureName &&
            item.menuName === updatedItem.menuName &&
            item.subMenuName === updatedItem.subMenuName
        );

        let newUpdatedFeatures = [...updatedFeatures];
        if (existingIndex > -1) {
            newUpdatedFeatures[existingIndex] = updatedItem;
        } else {
            newUpdatedFeatures.push(updatedItem);
        }
        this.setState({
            datalist: updatedDatalist,
            updatedFeatures:newUpdatedFeatures,
        })
    }

    onCancelClick = () => {
        this.props.history.push(Constants.URL_CLIENTS);
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
        });
        this.props.history.push(Constants.URL_CLIENTS);
    }
    /******************API CALLS ********************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });
        fetch(Constants.Subsciptions+this.state.clientId,
        {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    datalist:data.subscriptionList,
                    companyName:data.clientCompanyName ?? "",
                })
            }else{
                this.setState({
                    datalist:[],
                    showLoader:false,
                    componentDidMountFlag:true,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    editSubscription = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.Subsciptions+this.state.clientId,
        {
            method: "PUT",
            mode: 'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                subscriptionList:JSON.stringify(this.state.updatedFeatures),
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.props.history.push(Constants.URL_CLIENTS);
            }else{
                this.setState({
                    datalist:[],
                    showLoader:false,
                    componentDidMountFlag:true,
                })
            }
        });
    }
    /******************API CALLS END HERE********************/

    render() {
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                {
                                    this.state.componentDidMountFlag &&
                                    
                                    <div className="card-col">
                                        <div className="review-roles-col">
                                            <h6>{this.state.companyName}</h6>
                                            <p>Subscriptions Feature</p>
                                            <div className='row custom-row'>
                                                {
                                                    !isEmptyArray(this.state.datalist) && 
                                                    this.state.datalist.map((item,idx) => {
                                                            return <div key={idx} className='col-md-4 custom-col mt-3'>
                                                                    <h6>
                                                                        {item.name}
                                                                    </h6>
                                                                    {item.subMenuList.map((subItem,subIdx) => {
                                                                        return <div key={subIdx} className='mt-2'>
                                                                            <p className='border-bottom submenu-border'>
                                                                                {subItem.subMenuName}
                                                                            </p>
                                                                            {subItem.featureList.map((featureItem,featureIdx) => {
                                                                                return <tr>
                                                                                    <td>
                                                                                        {featureItem.frontEndName}
                                                                                    </td>
                                                                                    <td>
                                                                                        <UserRoleCheckBoxLayout themeSettings={themeSettings}>
                                                                                            <input 
                                                                                                type="checkbox"
                                                                                                name={featureItem.frontEndName}
                                                                                                id={`feature-${idx}-${subIdx}-${featureIdx}`}
                                                                                                onChange={(e) => this.handleRights(e,idx,subIdx,featureIdx)}
                                                                                                checked={featureItem.hasRights === "Y" ? true : false}
                                                                                                disabled={!featureItem.isEditable}
                                                                                            />
                                                                                            <label for={`feature-${idx}-${subIdx}-${featureIdx}`}></label>
                                                                                        </UserRoleCheckBoxLayout>
                                                                                    </td>
                                                                                </tr>
                                                                            })}
                                                                        </div>
                                                                    })}
                                                            </div>
                                                    })
                                                }
                                            </div>
                                            <div className="common-close-save">
                                                <div className="common-close-save-col">
                                                    <button onClick={this.onCancelClick} type="button" className="common-close">Cancel</button>
                                                    {this.state.datalist.length > 0 &&
                                                        <PageSaveButton
                                                            themeSettings={themeSettings}
                                                            onClick={this.editSubscription} type="button" className="common-save">
                                                                Save
                                                        </PageSaveButton>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <AlertDialog 
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                            themeSettings={themeSettings}
                        />
                    </section>
                </main>
            </Router>
        );
    }
}

export default EditSubscription;